import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, StlSystemIds, } from "@inter-ikea-core/core";
import RequireSizeAdjustmentComponent from "@inter-ikea-storagetwo/range/dist/components/RequireSizeAdjustmentComponent";
import { NO_UPRIGHTS } from "../constants/errors";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { getDiagonalBracketConnectorKey, getSectionUprightsByUpright, } from "../utils/sectionsHelpers";
import { findUniqueConnections } from "../utils/connectorHelpers";
import { RIGHT_ATTACH_TO_CLOTH_RAIL_CONNECTOR } from "../constants/connectorKeys";
import { adjustSize, getAdjustableMoveablePart, } from "@inter-ikea-storagetwo/range/dist/functions/adjustable";
import { ADJUSTABLE_CONNECTOR } from "@inter-ikea-storagetwo/range/dist/constants";
import { UPDATE } from "@inter-ikea-storagetwo/range/dist/constants";
import { getConnectorsComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { CONNECTOR_DOESNT_EXISTS, ENTITY_NULL, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
export default class ResizeAdjustableSystem extends SystemBase {
    constructor() {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = [
            StlSystemIds.ALIGNMENT_CONNECTION_CREATION_SYSTEM,
        ];
        this.id = "ResizeAdjustableOnAddSystem";
        this.mandatoryComponents = [COMPONENT_IDS.ADJUSTABLE_COMPONENT];
        this.updateAdjustableClothRail = (connection) => {
            const { hostConnectorEntity: shelf, guestConnectorEntity: clothRail } = connection;
            const rightShelf = getAdjustableMoveablePart(shelf);
            if (!rightShelf)
                throw new Error(ENTITY_NULL);
            const hostConnector = getConnectorsComponent(rightShelf).getConnectorByKey(RIGHT_ATTACH_TO_CLOTH_RAIL_CONNECTOR);
            if (!hostConnector)
                throw new Error(CONNECTOR_DOESNT_EXISTS);
            adjustSize(clothRail, ADJUSTABLE_CONNECTOR, rightShelf, hostConnector);
        };
        this.updateAdjustableShelf = (_entity, connection) => {
            const { hostConnector, hostConnectorEntity, guestConnector } = connection;
            const otherConnector = getDiagonalBracketConnectorKey(hostConnector.key, guestConnector.key);
            const { rightUpright } = getSectionUprightsByUpright(hostConnectorEntity);
            if (!rightUpright)
                throw new Error(NO_UPRIGHTS);
            const connector = getConnectorsComponent(rightUpright).getConnectorByKey(otherConnector);
            if (!connector)
                throw new Error(CONNECTOR_DOESNT_EXISTS);
            _entity.addComponent(new RequireSizeAdjustmentComponent(rightUpright, connector));
        };
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const connection = _newComponent.connections[0];
        _entity.hasComponent(COMPONENT_IDS.INSERT)
            ? this.updateAdjustableShelf(_entity, connection)
            : this.updateAdjustableClothRail(connection);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        if (!_entity.hasComponent(COMPONENT_IDS.INSERT))
            return;
        const { connections, action } = findUniqueConnections(_newComponent.connections, _oldComponent.connections);
        if (action !== UPDATE)
            return null;
        this.updateAdjustableShelf(_entity, connections[0]);
    }
}
